"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const UserCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-1310.000000, -342.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(1311.000000, 343.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.000000, -1.000000)",
          fill: color,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(13.000000, 13.000000) rotate(-180.000000) translate(-13.000000, -13.000000) translate(0.000000, -0.000000)",
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M20.0634126,4.56709333 C18.1524741,2.96479411 15.6889069,2 13,2 C10.3125385,2 7.85017446,2.96375716 5.9396695,4.56450998 C6.90439071,7.30457372 9.72692055,9.25 13.0020716,9.25 C16.2753674,9.25 19.0975818,7.30627898 20.0634126,4.56709333 Z M21.2250065,5.69576252 C20.2782005,7.78459909 18.4397954,9.41101231 16.1807993,10.2089935 C17.72944,11.2392424 18.75,13.0005103 18.75,15.000272 C18.75,18.1757232 16.1758632,20.75 13.0005439,20.75 C9.82433021,20.75 7.25,18.1759167 7.25,15.000272 C7.25,12.9998721 8.27116388,11.2382426 9.82075751,10.2081455 C7.56152517,9.40940577 5.72354945,7.78206909 4.77762425,5.69280335 C3.04968156,7.63575567 2,10.1952947 2,13 C2,19.0751322 6.92486775,24 13,24 C19.0751322,24 24,19.0751322 24,13 C24,10.1967184 22.9513838,7.63835415 21.2250065,5.69576252 Z M13.0005439,10.75 C10.6526536,10.75 8.75,12.6526141 8.75,15.000272 C8.75,17.3474573 10.6527251,19.25 13.0005439,19.25 C15.3474178,19.25 17.25,17.3473144 17.25,15.000272 C17.25,12.6532665 15.3483149,10.7508257 13.0020716,10.7500003 C13.0015623,10.75 13.0010531,10.75 13.0005439,10.7499999 Z M13,0 C20.1797017,0 26,5.82029825 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 0,20.1797017 0,13 C0,5.82029825 5.82029825,0 13,0 Z"
            })
          })
        })
      })
    })
  })]
});

UserCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = UserCircleIcon;
exports.default = _default;